/* ==================================================================
   Ziwara theme JS
   - Header scroll state
   - Mobile nav drawer
   - Reveal-on-scroll
   - AJAX cart (drawer, quick-add, qty, remove)
   - Reviews 3D carousel
   - PDP gallery / zoom / quantity / add-to-bag / sticky bar
   - Toast notifications
   ================================================================== */

document.addEventListener('DOMContentLoaded', function () {

  /* ================== Toast ================== */
  var toastEl = document.getElementById('toast');
  var toastTxt = document.getElementById('toastText');
  var toastTimer;
  window.toast = function (msg) {
    if (!toastEl || !toastTxt) return;
    toastTxt.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 2200);
  };

  /* ================== Header scroll state ================== */
  var header = document.getElementById('header');
  var stickyBar = document.getElementById('stickyBar');
  var pdpSection = document.getElementById('pdp');

  window.addEventListener('scroll', function () {
    if (header) header.classList.toggle('scrolled', window.scrollY > 18);

    if (stickyBar && pdpSection) {
      var addBtn = document.getElementById('pdpAdd');
      if (addBtn) {
        var r = addBtn.getBoundingClientRect();
        var pdpR = pdpSection.getBoundingClientRect();
        var show = r.bottom < 100 && pdpR.bottom > 200;
        stickyBar.classList.toggle('show', show);
      }
    }
  }, { passive: true });

  /* ================== Reveal on scroll ================== */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  /* ================== Mobile nav ================== */
  var mnav = document.getElementById('mnav');
  var openMenu = document.getElementById('openMenu');
  var closeMenu = document.getElementById('closeMenu');
  if (openMenu && mnav) openMenu.addEventListener('click', function () { mnav.classList.add('open'); });
  if (closeMenu && mnav) closeMenu.addEventListener('click', function () { mnav.classList.remove('open'); });
  if (mnav) {
    mnav.querySelectorAll('.mnav-link').forEach(function (a) {
      a.addEventListener('click', function () { mnav.classList.remove('open'); });
    });
  }

  /* ================== Cart drawer (Shopify AJAX Cart) ================== */
  var drawer = document.getElementById('drawer');
  var scrim = document.getElementById('scrim');
  var openCartBtn = document.getElementById('openCart');
  var closeCartBtn = document.getElementById('closeCart');
  var itemsEl = document.getElementById('cartItems');
  var subEl = document.getElementById('cartSubtotal');
  var totalEl = document.getElementById('cartTotal');
  var countEl = document.getElementById('cartCount');
  var drCount = document.getElementById('drawerCount');
  var shipEl = document.getElementById('shipNote');
    var FREE_SHIP = window.ziwaraFreeShippingThreshold || 149900;

  function moneyFmt(cents) {
    return (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cents, window.ziwaraMoneyFormat)
      : '₹' + (cents / 100).toLocaleString('en-IN');
  }

  function openCart() { if (drawer) drawer.classList.add('open'); if (scrim) scrim.classList.add('open'); }
  function closeCart() { if (drawer) drawer.classList.remove('open'); if (scrim) scrim.classList.remove('open'); }
  window.openCart = openCart;
  window.closeCart = closeCart;

  if (openCartBtn) openCartBtn.addEventListener('click', function (e) { e.preventDefault(); fetchCart().then(openCart); });
  if (closeCartBtn) closeCartBtn.addEventListener('click', closeCart);
  if (scrim) scrim.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); if (mnav) mnav.classList.remove('open'); }
  });

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  function renderCart(cart) {
    if (!cart) return;
    var count = cart.item_count || 0;
    if (countEl) countEl.textContent = count;
    if (drCount) drCount.textContent = count;
    if (subEl) subEl.textContent = moneyFmt(cart.total_price);
    if (totalEl) totalEl.textContent = moneyFmt(cart.total_price);

    if (shipEl) {
      if (cart.total_price === 0) {
        shipEl.innerHTML = '🚚 Free shipping on orders over ' + moneyFmt(FREE_SHIP);
      } else if (cart.total_price >= FREE_SHIP) {
        shipEl.innerHTML = " You've unlocked FREE shipping";
      } else {
        shipEl.innerHTML = '🚚 Add <b>' + moneyFmt(FREE_SHIP - cart.total_price) + '</b> more for FREE shipping';
      }
    }

    if (!itemsEl) return;

    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '<div class="cart-empty"><h4>Your bag is empty</h4><p>Add a piece to start your story.</p>' +
        '<button class="btn btn-gold" style="margin-top:18px" data-close-cart-link href="/collections/bestsellers">Browse Bestsellers</button></div>';
      var browseBtn = itemsEl.querySelector('[data-close-cart-link]');
      if (browseBtn) browseBtn.addEventListener('click', function () {
        closeCart();
        var best = document.querySelector('#best');
        if (best) best.scrollIntoView({ behavior: 'smooth' });
      });
      return;
    }

    itemsEl.innerHTML = cart.items.map(function (item) {
      var img = item.image ? item.image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_200x$1$2') : '';
      return '' +
        '<div class="cart-item" data-key="' + item.key + '">' +
          '<img src="' + img + '" alt="' + (item.product_title || '').replace(/"/g, '&quot;') + '"/>' +
          '<div>' +
            '<small>' + (item.product_type || item.vendor || '') + '</small>' +
            '<h4>' + item.product_title + '</h4>' +
            '<div class="price">' + moneyFmt(item.final_price) + '</div>' +
            '<div class="qty">' +
              '<button data-qty-change="-1" aria-label="Decrease">\u2212</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button data-qty-change="1" aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
          '<button class="rem" data-remove-item aria-label="Remove">Remove</button>' +
        '</div>';
    }).join('');

    itemsEl.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var row = btn.closest('.cart-item');
        var key = row.getAttribute('data-key');
        var current = parseInt(row.querySelector('.qty span').textContent, 10);
        var delta = parseInt(btn.getAttribute('data-qty-change'), 10);
        updateLine(key, current + delta);
      });
    });
    itemsEl.querySelectorAll('[data-remove-item]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var row = btn.closest('.cart-item');
        updateLine(row.getAttribute('data-key'), 0);
      });
    });
  }

  function updateLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

    window.addItemToCart = function (variantId, qty, productName, btn) {
    qty = qty || 1;

    // double tap pe dobara add na ho
    if (btn && btn.dataset.busy) return Promise.resolve();

    var label = btn ? btn.innerHTML : '';
    function resetBtn() {
      if (!btn) return;
      btn.innerHTML = label;
      btn.classList.remove('is-adding');
      delete btn.dataset.busy;
    }
    if (btn) {
      btn.dataset.busy = '1';
      btn.classList.add('is-adding');
      btn.innerHTML = 'Adding…';
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('Could not add to bag');
      return fetchCart();
    }).then(function () {
      openCart();
      if (btn) {
        btn.classList.remove('is-adding');
        btn.innerHTML = '✓ Added';
        setTimeout(resetBtn, 1200);
      }
    }).catch(function () {
      resetBtn();
      toast('That item is currently unavailable');
    });
  };

  // Quick-add buttons on product cards (sections/snippets/product-card.liquid)
  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.getAttribute('data-variant-id');
      var name = btn.getAttribute('data-product-title');
      if (!variantId) return;
      window.addItemToCart(variantId, 1, name, btn);
    });
  });

  // Initial cart state on load (for header bag count)
  fetchCart();

  /* ================== Reviews 3D carousel ================== */
  (function () {
    var items = document.querySelectorAll('.rc3-item');
    var dots = document.querySelectorAll('.rc3-dot');
    var wrap = document.getElementById('rc3Wrap');
    if (!items.length || !wrap) return;

    var n = items.length;
    var cur = Math.min(2, n - 1);

    var desktop = {
      '-2': { x: '-680px', z: '-200px', ry: '35deg', s: '.72', o: '.3' },
      '-1': { x: '-340px', z: '-80px', ry: '18deg', s: '.85', o: '.62' },
      '0': { x: '0', z: '0', ry: '0deg', s: '1', o: '1' },
      '1': { x: '340px', z: '-80px', ry: '-18deg', s: '.85', o: '.62' },
      '2': { x: '680px', z: '-200px', ry: '-35deg', s: '.72', o: '.3' }
    };
    var mobile = {
      '-2': { x: '-460px', z: '-160px', ry: '28deg', s: '.7', o: '.25' },
      '-1': { x: '-240px', z: '-60px', ry: '14deg', s: '.82', o: '.55' },
      '0': { x: '0', z: '0', ry: '0deg', s: '1', o: '1' },
      '1': { x: '240px', z: '-60px', ry: '-14deg', s: '.82', o: '.55' },
      '2': { x: '460px', z: '-160px', ry: '-28deg', s: '.7', o: '.25' }
    };

    function isMob() { return window.innerWidth <= 768; }

    function update() {
      var pos = isMob() ? mobile : desktop;
      items.forEach(function (item, i) {
        var offset = ((i - cur) % n + n) % n;
        if (offset > Math.floor(n / 2)) offset -= n;
        var key = String(offset);
        if (pos[key]) {
          var p = pos[key];
          item.style.transform = 'translateX(' + p.x + ') translateZ(' + p.z + ') rotateY(' + p.ry + ') scale(' + p.s + ')';
          item.style.opacity = p.o;
          item.style.zIndex = offset === 0 ? '5' : Math.abs(offset) === 1 ? '3' : '1';
          item.style.pointerEvents = 'auto';
          item.style.visibility = 'visible';
        } else {
          item.style.opacity = '0';
          item.style.pointerEvents = 'none';
          item.style.visibility = 'hidden';
        }
      });
      dots.forEach(function (d, i) { d.classList.toggle('rc3-dot-on', i === cur); });
    }

    window.rc3Move = function (dir) { cur = (cur + dir + n) % n; update(); };
    window.rc3Go = function (i) { cur = i; update(); };

    items.forEach(function (item, i) {
      item.addEventListener('click', function () { if (i !== cur) { cur = i; update(); } });
    });

    var tx = 0;
    wrap.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    wrap.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > 40) window.rc3Move(dx < 0 ? 1 : -1);
    }, { passive: true });

    window.addEventListener('resize', update);
    update();
  })();

  /* ================== PDP gallery / zoom ================== */
  (function () {
    var thumbsEl = document.getElementById('pdpThumbs');
    var mainImg = document.getElementById('pdpMainImg');
    var mainBox = document.getElementById('pdpMain');
    if (!thumbsEl || !mainImg || !mainBox) return;

    thumbsEl.addEventListener('click', function (e) {
      var b = e.target.closest('.thumb');
      if (!b) return;
      thumbsEl.querySelectorAll('.thumb').forEach(function (t) { t.classList.remove('active'); });
      b.classList.add('active');
      var src = b.getAttribute('data-full');
      if (src) mainImg.src = src;
    });

    mainBox.addEventListener('click', function () { mainBox.classList.toggle('zoomed'); });
    mainBox.addEventListener('mousemove', function (e) {
      if (!mainBox.classList.contains('zoomed')) return;
      var r = mainBox.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      mainImg.style.transformOrigin = x + '% ' + y + '%';
    });
  })();

  /* ================== PDP quantity + add to bag ================== */
  (function () {
    var qMinus = document.getElementById('qMinus');
    var qPlus = document.getElementById('qPlus');
    var qVal = document.getElementById('qVal');
    var pdpAdd = document.getElementById('pdpAdd');
    var stickyAdd = document.getElementById('stickyAdd');
    if (!qVal) return;

    var qty = 1;
    function setQty(v) { qty = Math.max(1, v); qVal.textContent = qty; }
    if (qMinus) qMinus.addEventListener('click', function () { setQty(qty - 1); });
    if (qPlus) qPlus.addEventListener('click', function () { setQty(qty + 1); });

    function add(btn) {
      if (!pdpAdd) return;
      var variantId = pdpAdd.getAttribute('data-variant-id');
      var name = pdpAdd.getAttribute('data-product-title');
      if (!variantId) return;
      window.addItemToCart(variantId, qty, name, btn);
          if (pdpAdd) pdpAdd.addEventListener('click', function () { add(pdpAdd); });
    if (stickyAdd) stickyAdd.addEventListener('click', function () { add(stickyAdd); });
    }
    if (pdpAdd) pdpAdd.addEventListener('click', add);
    if (stickyAdd) stickyAdd.addEventListener('click', add);
  })();

  /* ================== Newsletter ================== */
  document.querySelectorAll('[data-newsletter-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      // Shopify's customer form handles the POST; just show a friendly toast.
      setTimeout(function () { toast('Welcome to the house \u2726'); }, 50);
    });
  });

});
